import {createAsyncThunk} from "@reduxjs/toolkit";
import request from "../../../../service";
import {IErrorResponse} from "../../../../types";
import {deletedRestoreStudents, deleteStudents, setStudents, setStudentsRestore} from "./studentsSlice";
import {
    deletedRestoreYears,
    setYearsRestoreData
} from "@pages/EducationalSettings/AcademicYear/store/academicYearSlice";

const GetStudents = createAsyncThunk(
    "get/students",
    async (_, { rejectWithValue,dispatch }) => {
        try {
            const response = await request.get("/students");
            dispatch(setStudents(response.data));
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);

const CreateStudents = createAsyncThunk(
    "create/students",
    async (payload: any, {rejectWithValue}) => {
        try {
            const response = await request.post("/students", payload);

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);


const EditStudents = createAsyncThunk(
    "edit/students",
    async (data: any, { rejectWithValue }) => {
        const {formData,id} =data
        try {
            const response = await request.put(`/students/${id}`, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            });
            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response?.data?.message || "unexpected_fail");
        }
    }
);



const DeleteStudents = createAsyncThunk(
    "delete/students/",
    async ( id : number, thunkAPI) => {
        try {
            const response = await request.delete(`/students/${id}`);
            thunkAPI.dispatch(deleteStudents(id));
            return response.data;
        }  catch (error) {
            const typedError = error as IErrorResponse;
            return thunkAPI.rejectWithValue(typedError.response.data.message || "unexpected_fail");
        }
    }
);

const GetDeleteStudents= createAsyncThunk(
    "get/delete/students",
    async (_,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.get(`/students/deleted-items`);

            dispatch(setStudentsRestore(response.data));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);


const RestoreDeleteStudents = createAsyncThunk(
    "restore/delete/students",
    async (id:number,{ dispatch,rejectWithValue }) => {
        try {
            const response = await request.post(`/students/restore/${id}`);

            dispatch(deletedRestoreStudents(id));

            return response.data;
        } catch (error) {
            const typedError = error as IErrorResponse;
            return rejectWithValue(typedError.response.data.message || "unexpected_fail");

        }
    }
);





export {
    CreateStudents,
    GetStudents,
    DeleteStudents,
    EditStudents,
    RestoreDeleteStudents,
    GetDeleteStudents
}